(function () {
  'use strict';
  var COLORS = ['piros','bordó','cseresznyepiros','arany','pezsgőszín','ezüst','fehér','fekete','kék','sötétkék','zöld','lila','rózsaszín','púder rózsaszín','babarózsaszín','rosegold','pink','barna','borostyán','réz','narancs','sárga','szürke','bézs'];
  var SIZE_RE = /^\d+(\.\d+)?\s?cm$/;
  var FSZIN = { feher: 'Fehér', arany: 'Arany', piros: 'Piros', ezust: 'Ezüst', zold: 'Zöld', fekete: 'Fekete' };
  var CUSTOM_TYPE = 'Egyedi termékek';
  var ADDON_MAX_PRICE = 9999;

  function fmt(n) { return Math.round(n).toLocaleString('hu-HU') + '\u00a0Ft'; }
  function low(arr) { return (arr || []).map(function (t) { return String(t).toLowerCase().trim(); }); }
  function tagList(t) { if (typeof t === 'string') t = t.split(','); return low(t); }
  function colorsOf(tags) { return tags.filter(function (t) { return COLORS.indexOf(t) > -1; }); }
  function overlap(a, b) { var n = 0; a.forEach(function (x) { if (b.indexOf(x) > -1) n++; }); return n; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  var productsPromise = null;
  function loadProducts() {
    if (productsPromise) return productsPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem('kdBundleProducts') || 'null');
      if (c && Date.now() - c.t < 600000) return (productsPromise = Promise.resolve(c.p));
    } catch (e) {}
    function page(n, acc) {
      return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var p = d.products || [];
          acc = acc.concat(p);
          return p.length === 250 && n < 4 ? page(n + 1, acc) : acc;
        });
    }
    productsPromise = page(1, []).then(function (all) {
      var slim = all.map(function (p) {
        var v = null;
        (p.variants || []).some(function (x) { if (x.available) { v = x; return true; } return false; });
        return { id: p.id, title: p.title, handle: p.handle, type: p.product_type || '', tags: tagList(p.tags),
          img: p.images && p.images[0] ? p.images[0].src : '', vid: v ? v.id : null, price: v ? parseFloat(v.price) : 0 };
      });
      try { sessionStorage.setItem('kdBundleProducts', JSON.stringify({ t: Date.now(), p: slim })); } catch (e) {}
      return slim;
    });
    return productsPromise;
  }

  function Bundle(root) {
    var self = this;
    this.root = root;
    this.pid = Number(root.getAttribute('data-product-id'));
    this.ptype = root.getAttribute('data-product-type') || '';
    this.variants = JSON.parse(root.querySelector('[data-kd-variants]').textContent);
    this.tags = low(JSON.parse(root.querySelector('[data-kd-tags]').textContent));
    this.colors = colorsOf(this.tags);
    this.sizes = this.tags.filter(function (t) { return SIZE_RE.test(t); });
    this.scope = root.closest('product-info') || root.closest('section') || document;
    this.tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    this.addonWrap = root.querySelector('[data-addons]');
    this.addonList = root.querySelector('[data-addons-list]');
    this.cta = root.querySelector('[data-cta]');
    this.ctaTotal = root.querySelector('[data-cta-total]');
    this.msg = root.querySelector('[data-msg]');
    this.addons = [];
    this.selected = null;

    this.tiers.forEach(function (t) {
      t.querySelector('input').addEventListener('change', function () { self.render(); });
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        setTimeout(function () { self.render(); }, 150);
      }
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { self.render(); }, 0); });
      }
    } catch (e) {}
    this.cta.addEventListener('click', function () { self.submit(); });
    this.render();
    this.loadAddons();
  }

  Bundle.prototype.variant = function () {
    var input = this.scope.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = input ? Number(input.value) : null;
    var v = null;
    this.variants.forEach(function (x) { if (x.id === id) v = x; });
    if (!v) this.variants.some(function (x) { if (x.available) { v = x; return true; } return false; });
    return v || this.variants[0];
  };

  Bundle.prototype.render = function () {
    var v = this.variant();
    var unit = v.price / 100;
    var selected = null;
    this.tiers.forEach(function (t) {
      var qty = Number(t.getAttribute('data-qty'));
      var pct = Number(t.getAttribute('data-pct'));
      var input = t.querySelector('input');
      var blocked = !v.available || (v.tracked && v.qty < qty);
      input.disabled = blocked;
      t.classList.toggle('is-disabled', blocked);
      var full = unit * qty;
      var total = Math.round(full * (1 - pct / 100));
      t.querySelector('[data-price]').textContent = fmt(total);
      var compareFull = pct > 0 ? full : (v.compare > v.price ? (v.compare / 100) * qty : 0);
      t.querySelector('[data-compare]').textContent = compareFull ? fmt(compareFull) : '';
      t.querySelector('[data-save]').textContent = pct > 0 ? 'Megtakarítás: ' + fmt(full - total) : '';
      var note = t.querySelector('[data-note]');
      if (note) note.hidden = !(blocked && v.available);
      var on = input.checked && !blocked;
      t.classList.toggle('is-selected', on);
      if (on) selected = { qty: qty, total: total };
    });
    if (!selected) {
      var first = this.tiers.filter(function (t) { return !t.querySelector('input').disabled; })[0];
      if (first && !first.querySelector('input').checked) {
        first.querySelector('input').checked = true;
        return this.render();
      }
    }
    var addonSum = 0;
    this.addons.forEach(function (a) { if (a.toggle.checked) addonSum += a.price; });
    this.selected = selected;
    this.ctaTotal.textContent = selected ? fmt(selected.total + addonSum) : '';
    this.cta.disabled = !selected;
  };

  Bundle.prototype.loadAddons = function () {
    var self = this;
    loadProducts().then(function (list) {
      var picks = [];
      if (self.colors.length) {
        list.filter(function (p) {
          return p.id !== self.pid && p.vid && p.price <= ADDON_MAX_PRICE && p.type !== CUSTOM_TYPE && !/szalag/i.test(p.title) && overlap(p.tags, self.colors) > 0;
        }).map(function (p) {
          var s = overlap(colorsOf(p.tags), self.colors) * 10;
          if (p.type === self.ptype) s += 4;
          s += overlap(p.tags.filter(function (t) { return SIZE_RE.test(t); }), self.sizes) * 2;
          return { p: p, s: s };
        }).sort(function (a, b) { return b.s - a.s; }).slice(0, 2).forEach(function (c) {
          picks.push({ p: c.p, custom: false });
        });
      }
      var orbs = list.filter(function (p) {
        return p.vid && p.type === CUSTOM_TYPE && p.tags.indexOf('8 cm') > -1;
      }).map(function (p) {
        return { p: p, s: overlap(colorsOf(p.tags), self.colors) };
      }).sort(function (a, b) { return b.s - a.s; });
      if (orbs.length) picks.push({ p: orbs[0].p, custom: true });
      if (!picks.length) return;
      picks.forEach(function (x) { self.addRow(x.p, x.custom); });
      self.addonWrap.hidden = false;
      self.render();
    }).catch(function () {});
  };

  Bundle.prototype.addRow = function (p, custom) {
    var self = this;
    var row = el('div', 'kd-addon' + (custom ? ' kd-addon--custom' : ''));
    var main = el('div', 'kd-addon__main');
    var link = el('a', 'kd-addon__img');
    link.href = '/products/' + p.handle;
    if (p.img) {
      var img = el('img');
      img.src = sized(p.img, 160); img.alt = p.title; img.loading = 'lazy'; img.width = 56; img.height = 56;
      link.appendChild(img);
    }
    var info = el('div', 'kd-addon__info');
    if (custom) info.appendChild(el('span', 'kd-addon__eyebrow', 'Egyedi felirattal'));
    var t = el('a', 'kd-addon__title', p.title);
    t.href = '/products/' + p.handle;
    info.appendChild(t);
    info.appendChild(el('span', 'kd-addon__price', '+ ' + fmt(p.price)));
    var sw = el('label', 'kd-switch');
    var cb = el('input');
    cb.type = 'checkbox';
    cb.setAttribute('aria-label', p.title + ' hozzáadása');
    sw.appendChild(cb);
    sw.appendChild(el('span', 'kd-switch__track'));
    main.appendChild(link); main.appendChild(info); main.appendChild(sw);
    row.appendChild(main);
    var addon = { p: p, price: p.price, toggle: cb, custom: custom, row: row };
    if (custom) {
      var fields = el('div', 'kd-addon__fields');
      fields.hidden = true;
      var txt = el('input', 'kd-addon__input');
      txt.type = 'text'; txt.maxLength = 30; txt.placeholder = 'Felirat (max. 30 karakter)';
      txt.setAttribute('aria-label', 'Felirat');
      fields.appendChild(txt);
      var colors = p.tags.filter(function (x) { return x.indexOf('fszin:') === 0; })
        .map(function (x) { return FSZIN[x.replace('fszin:', '')]; }).filter(Boolean);
      if (!colors.length) colors = ['Fehér'];
      var sel = el('select', 'kd-addon__select');
      sel.setAttribute('aria-label', 'A felirat színe');
      colors.forEach(function (c) { var o = el('option', null, 'Színe: ' + c); o.value = c; sel.appendChild(o); });
      fields.appendChild(sel);
      var font = el('select', 'kd-addon__select');
      font.setAttribute('aria-label', 'Betűtípus');
      ['Írott', 'Nyomtatott'].forEach(function (f) { var o = el('option', null, 'Betű: ' + f); o.value = f; font.appendChild(o); });
      fields.appendChild(font);
      row.appendChild(fields);
      addon.text = txt; addon.color = sel; addon.font = font; addon.fields = fields;
    }
    cb.addEventListener('change', function () {
      row.classList.toggle('is-on', cb.checked);
      if (addon.fields) {
        addon.fields.hidden = !cb.checked;
        if (cb.checked) addon.text.focus();
      }
      self.render();
    });
    this.addons.push(addon);
    this.addonList.appendChild(row);
  };

  Bundle.prototype.say = function (text, isErr) {
    this.msg.textContent = text;
    this.msg.classList.toggle('is-error', !!isErr);
  };

  Bundle.prototype.submit = function () {
    var self = this;
    if (!this.selected) return;
    var v = this.variant();
    var items = [{ id: v.id, quantity: this.selected.qty }];
    for (var i = 0; i < this.addons.length; i++) {
      var a = this.addons[i];
      if (!a.toggle.checked) continue;
      var item = { id: a.p.vid, quantity: 1 };
      if (a.custom) {
        var text = a.text.value.trim();
        if (!text) {
          this.say('Írd be a gömb feliratát, vagy kapcsold ki a gömböt.', true);
          a.text.focus();
          return;
        }
        item.properties = { 'Felirat': text, 'Felirat színe': a.color.value, 'Betűtípus': a.font.value };
      }
      items.push(item);
    }
    this.cta.disabled = true;
    this.cta.classList.add('is-loading');
    this.say('Kosárba teszem...');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function () {
      self.say('Kosárba téve, átirányítás...');
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function (err) {
      self.say((err && (err.description || err.message)) || 'Hiba történt, kérjük próbáld újra.', true);
      self.cta.disabled = false;
      self.cta.classList.remove('is-loading');
    });
  };

  function init() {
    document.querySelectorAll('[data-kd-bundle]').forEach(function (r) {
      if (!r.__kdBundle) { r.__kdBundle = true; new Bundle(r); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
